import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/sessions/session-student-label.html";

import "Styles/components/session-student-label.scss";

class SessionStudentLabel
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.studentLabel = options.studentLabel;
    this.onStudentClicked = options.onStudentClicked;
    this.getStudentIndex = options.getStudentIndex;
    this.inGroup = options.inGroup;
    this.canBeClicked = options.canBeClicked;
    this.selected = false;
    this.blocked = false;
  }

  get studentLabel()
  {
    return this._studentLabel;
  }

  set studentLabel(studentLabel)
  {
    this._studentLabel = studentLabel;
    this.updateSessionStudentLabel();
  }

  static setUpSessionStudentLabel(options)
  {
    let instance = new SessionStudentLabel(options);
    instance.render();
    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    let that = this;
    this.$element.on("click", function(e)
    {
      that.studentClicked();
    });

    this.$element.on("dragstart", function(e)
    {
      //e.preventDefault();
      e.stopPropagation();
      that.onStudentDrag(e);
    });
  }

  onStudentDrag(e)
  {
    e.dataTransfer.setData("student/id", this.getStudentIndex(this));
    e.dataTransfer.effectAllowed = "copy";

    if(!this.inGroup)
    {

    }
    else
    {

    }
  }

  studentClicked()
  {
    if(!this.blocked && this.canBeClicked)
    {
      this.toggleSelected();
      this.onStudentClicked(this);
    }
  }

  toggleSelected()
  {
    if(this.$element.hasClass("selected"))
    {
      this.selected = false;
      this.$element.removeClass("selected");
    }
    else
    {
      this.selected = true;
      this.$element.addClass("selected");
    }

  }

  setBlocked()
  {
    this.blocked = true;
    this.selected = false;
    this.$element.removeClass("selected");
    this.$element.addClass("blocked");
  }

  setUnblocked()
  {
    this.blocked = false;
    this.$element.removeClass("blocked");

  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateSessionStudentLabel();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateSessionStudentLabel() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $studentLabelName = this.$element.find("[data-bind-target='student-label-name']");
      $studentLabelName.empty();

      if (utils.isNotNull(this.studentLabel) && utils.isNotNull(this.studentLabel.name)) {
        $studentLabelName.text(this.studentLabel.name);
      }

    }
  }

}

export default SessionStudentLabel;



// WEBPACK FOOTER //
// ./app/js/components/session-student-label.js